/**
 * Shared site header — logo background image is set inline (not via CSS url()) because the
 * SVG lives in public_html/brandportal/newsletter/images/ (deployed separately, outside this
 * app's own build output), so it must not be resolved as a webpack module.
 */
export default function Header() {
  return (
    <nav className="header">
      <div className="top-row">
        <a
          className="logo-wrapper"
          href="https://www.skoda.pl/"
          target="_self"
          style={{ backgroundImage: 'url(/brandportal/newsletter/images/SkodaLogo2023.svg)' }}
        >
          <span className="visually-hidden">Škoda</span>
        </a>
      </div>
      <div className="bottom-row">
        <a href="https://www.skoda.pl/" target="_self">
          Przejdź do&nbsp;strony głównej
        </a>
      </div>
    </nav>
  );
}
